const RESERVED_WORDS = new Set([
    'SUM', 'IF', 'AND', 'OR', 'NOT', 'TRUE', 'FALSE', 'NULL',
    'MIN', 'MAX', 'AVG', 'COUNT', 'ABS', 'ROUND',
]);
/**
 * Generate the next rowId by finding the highest numeric rowId and adding 10.
 * First row gets "10", second gets "20", etc.
 */
export function generateRowId(existingRowIds) {
    let maxNumeric = 0;
    for (const id of existingRowIds) {
        const num = parseInt(id, 10);
        if (!isNaN(num) && String(num) === id && num > maxNumeric) {
            maxNumeric = num;
        }
    }
    return String(maxNumeric + 10);
}
/**
 * Validate a rowId. Returns null if valid, or an error message string.
 * @param currentId - The node's own rowId (excluded from uniqueness check when editing)
 */
export function validateRowId(rowId, existingRowIds, currentId) {
    if (!rowId || rowId.trim().length === 0) {
        return 'Row ID cannot be empty';
    }
    if (/\s/.test(rowId)) {
        return 'Row ID cannot contain spaces';
    }
    // Cannot start with a digit followed by letters (e.g., "1ABC")
    if (/^\d+[a-zA-Z]/.test(rowId)) {
        return 'Row ID cannot start with digits followed by letters';
    }
    if (RESERVED_WORDS.has(rowId.toUpperCase())) {
        return `"${rowId}" is a reserved word`;
    }
    const otherIds = currentId
        ? existingRowIds.filter((id) => id !== currentId)
        : existingRowIds;
    if (otherIds.includes(rowId)) {
        return 'Row ID must be unique';
    }
    return null;
}
//# sourceMappingURL=row-id-utils.js.map